module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-cart"
  }, [_c('h2', {
    staticClass: "ui icon header center aligned"
  }, [_c('i', {
    staticClass: "shop icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            " + _vm._s(_vm.lang.say('TEXT_CART_EMPTY')) + "\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.say('SUB_TITLE_CART_EMPTY')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3118cd30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmptyCart.vue
// module id = 377
// module chunks = 0